import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import config from './config';
import {
  CONNECTIONS_QUERY_KEY,
  PROVIDER_NOT_CONNECTED_PROBLEM_TYPE,
} from './utils/consts';
import { problemType, statusOf } from './utils/problem';

const onProviderNotConnected = (error: unknown) => {
  if (problemType(error) === PROVIDER_NOT_CONNECTED_PROBLEM_TYPE) {
    queryClient.invalidateQueries({ queryKey: [CONNECTIONS_QUERY_KEY] });
  }
};

const queryClient: QueryClient = new QueryClient({
  queryCache: new QueryCache({ onError: onProviderNotConnected }),
  mutationCache: new MutationCache({ onError: onProviderNotConnected }),
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const status = statusOf(error);
        return (status === undefined || status >= 500) && failureCount < 3;
      },
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

datadogRum.init({
  applicationId: config.datadogApplicationId,
  clientToken: config.datadogClientToken,
  site: 'datadoghq.com',
  service: 'osep-generator',
  env: 'tst',
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: 'mask-user-input',
  plugins: [reactPlugin({ router: false })],
});

datadogRum.startSessionReplayRecording();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools />
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
